import { QuestionBase } from './question-base';

export class CheckboxQuestion extends QuestionBase<string> {
  controlType = 'checkbox';
  color: string;

  constructor(options: any = {}) {
    super(options);
    this.color = options['color'] || 'primary';
    this.value = options['value'] || 'false';
  }
}
